import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AbLocale } from "app/abstract/full-pages/locale/locale.abstract";

@Injectable({ providedIn: 'root' })
export class LocaleService extends AbLocale {

    constructor(httpClient: HttpClient) {
        super(httpClient);
    }


    getLocales(): Observable<any> {
        return this.get("public/locale/all/");
    }

    getLocaleIntegrador(): Observable<any> {
        let urlContext = window.location.href.split('//')[1].split('.')[0];
        return this.get("public/locale/integrador/", urlContext);
    }

    getLocaleUsuario(): Observable<any> {
        return this.get("public/locale/usuario/");
    }

    getLocaleUsuarioOrIntegrador(): Observable<any> {
        let urlContext = window.location.href.split('//')[1].split('.')[0];
        return this.get("public/locale/usuario_or_integrador/", urlContext);
    }

    alterarLocaleUsuario(locale): Observable<any> {
        return this.post("public/locale/usuario/", locale);
    }
}